<template>
  <div style="width:100%;">
    <div class="quick-view-vue__loading" v-if="isLoading">
      <Loading />
    </div>
    <div v-if="!isLoading">
      <div
        class="col-4 hide-small"
        :class="isShopTitle ? 'quick-view-vue__img-container' : ''"
        v-if="hasImage"
      >
        <a :href="href" style="max-width: 260px; display: inline-block;"
          ><img
            class="quick-view-vue__img"
            :src="imgThumbnailUrl"
            :alt="productInfo.Name"
        /></a>
      </div>
      <div
        class="col-4 quick-view-vue__img-container hide-small"
        v-if="!hasImage && isShopTitle"
      >
        <a :href="href" style="max-width: 260px; display: inline-block;"
          ><img
            class="quick-view-vue__img"
            src="/images/default-card.png"
            :alt="productInfo.Name"
        /></a>
      </div>
      <div
        class="col-4 quick-view-vue__cover add-bottom-margin hide-small"
        v-if="!hasImage && isPerformTitle"
      >
        <ul class="unstyled-list" style="max-width: 260px">
          <async-template
            v-bind:url="templateUrl"
            v-if="templateUrl.length > 0"
          ></async-template>
        </ul>
      </div>
      <div class="quick-view-vue__info col-8">
        <div class="flex flex--column flex--center">
          <h3 class="type-h3 add-small-bottom-margin">
            {{ productInfo.Name | truncate(66) }}
          </h3>
          <div class="color-off-black border-bottom">
            <p
              class="type-regular type-circular-italic add-x-small-bottom-margin"
              v-if="
                productInfo.TitleAuthors && productInfo.TitleAuthors.length > 0
              "
            >
              <span v-for="(author, index) in orderedAuthors" :key="author.FirstName + author.LastName">
                <a
                  class="type-link type-circular"
                  :href="getAuthorHref(author)"
                  v-if="author.Description"
                >
                  {{ author.FirstName }} {{ author.LastName }}
                </a>
                <span class="type-circular" v-else
                  >{{ author.FirstName }} {{ author.LastName }}</span
                >
                <span
                  v-if="
                    productInfo.TitleAuthors &&
                      index != productInfo.TitleAuthors.length - 1
                  "
                  >,</span
                >
              </span>
            </p>
            <p
              class="type-regular type-circular-italic type-regular display-block"
              v-if="productInfo.TitleTypeOfPlayAndGenre"
            >
              <span>{{ productInfo.TitleTypeOfPlayAndGenre }}</span>
              <span v-if="productInfo.TitleCasting">
                / {{ productInfo.TitleCasting }}</span
              >
            </p>
          </div>
          <p
            class="type-regular color-off-black add-top-margin no-bottom-margin"
            v-if="isPerformTitle"
            v-html="decodeHtmlEntities(productInfo.ShortDescription)"
          ></p>
          <div class="quick-view-vue__variants" v-if="isShopTitle && variants">
            <ul class="unstyled-list quick-view-vue__top-variants">
              <li v-for="item in topVariants" :key="item.Id">
                <a
                  :href="getVariantHref(item)"
                  class="type-link no-underline strict flex flex--align-center flex--between"
                >
                  <span>
                    <span class="type-h5 display-inline-block">{{
                      item.Name
                    }}</span>
                    <span class="type-x-small">{{ item.Sku }}</span>
                  </span>
                  <span class="type-x-small type-bold align-r">{{
                    item.ProductVariantPrice.Price
                  }}</span>
                </a>
              </li>
            </ul>
            <span
              class="display-inline-block type-small"
              v-if="theRest.length > 0"
              >Also available as:</span
            >
            <ul
              class="unstyled-list inline-list type-x-small display-inline-block"
            >
              <li v-for="(item, index) in theRest.slice(0, 2)" :key="item.Id">
                <a :href="getVariantHref(item)" class="type-link">{{
                  item.Name
                }}</a
                ><span v-if="index !== theRest.length - 1">,</span>
              </li>
              <li v-if="variants.length > 4">
                <a :href="href" class="type-link">See All</a>
              </li>
            </ul>
          </div>
          <div class="add-large-top-margin add-bottom-margin">
            <a class="btn" :href="href">View Full Page</a>
            <a
              class="btn btn--secondary"
              :href="licenceRequestPath"
              v-if="isPerformTitle && productInfo.CompletelyRestricted != true"
              >Request License</a
            >
            <a
              class="btn btn--secondary"
              :href="notifyPath"
              v-if="isPerformTitle && productInfo.CompletelyRestricted == true"
              >Notify Me When Available</a
            >
          </div>
          <AddToWishlist
            v-if="variants && variants[0] && variants[0].Id"
            :productId="product"
            :productVariantId="variants[0].Id"
            :wishlist-enum="catalog"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import _ from "lodash";

import Loading from "./Loading.vue";
import AddToWishlist from "./AddToWishlist.vue";

export default {
  name: "QuickViewModal",
  props: {
    product: {
      type: Number,
      required: true,
    },
    catalog: {
      type: String,
      required: true,
    },
  },
  components: {
    Loading,
    AddToWishlist,
  },
  data() {
    return {
      templateUrl: "",
      pathPrefix: "",
      authors: "",
      modalOpen: false,
      isPerformTitle: false,
      isShopTitle: false,
      isLoading: true,
      productInfo: {},
      theRest: [],
    };
  },
  mounted() {
    // set prefix for urls based on the passed catalog.
    // so that we can build links to scripts or titles
    this.isPerformTitle = this.catalog === "perform" || this.catalog === "author" ? true : false;
    this.isShopTitle = this.catalog === "shop";
    this.pathPrefix = this.isPerformTitle ? "p" : "s";
    this.fetchProduct();
  },
  methods: {
    fetchProduct() {
      // wait till page is loaded and after stack is empty
      _.defer(() => {
        this.getProductInfo(this.product).then(() => {
          this.authors =
            this.productInfo.TitleAuthors &&
            this.productInfo.TitleAuthors.length <= 2
              ? this.buildAuthors(this.productInfo.TitleAuthors)
              : "Multiple Authors";
          this.templateUrl = `/api/v1/card/${this.productInfo.Id}.html?widget_type=quickview&show_card_text=false&show_quick_view=false`;
        });
      });
    },
    getProductInfo(id) {
      const endpoint = `/api/v1/products/${id}?includeAuthorTitles=false`;
      return axios
        .get(endpoint)
        .then(({ data }) => {
          this.productInfo = data;
          this.isLoading = false;
        })
        .catch((error) => {
          // console.log({error});
        });
    },

    // from https://laracasts.com/discuss/channels/general-discussion/escape-html-characters-with-vuejs
    decodeHtmlEntities(str) {
      var txt = document.createElement("textarea");
      txt.innerHTML = str;
      return txt.value;
    },

    // if there are two or less authors, return a formatted string
    buildAuthors(authors) {
      const auths = authors.map((author) => {
        return `${author.FirstName} ${author.LastName}`;
      });
      return auths.join(", ");
    },

    getAuthorHref(author) {
      return `/a/${author.Id}/${author.SeName}`;
    },

    getVariantHref(variant) {
      return `/s/${this.productInfo.Id}/${this.productInfo.SeName}?variantId=${variant.Id}`;
    },
  },
  filters: {
    truncate(string, value) {
      if (string && string.length > value) {
        return `${string.substring(0, value)}...`;
      } else {
        return string;
      }
    },
  },
  computed: {
    // returns the href value to link to the current product page/
    href() {
      return `/${this.pathPrefix}/${this.productInfo.Id}/${this.productInfo.SeName}`;
    },

    orderedAuthors() {
      return _.orderBy(this.productInfo.TitleAuthors, "DisplayOrder");
    },

    licenceRequestPath() {
      return `${window.env.ZOHRAB_LICENSE_DOMAIN}/performance-license/license?productId=${this.productInfo.Id}`;
    },

    notifyPath() {
      return `${window.env.ZOHRAB_LICENSE_DOMAIN}/performance-license/${this.productInfo.Id}/notify-me`;
    },

    // TODO - this is brittle. We need a better solution, plus a fallback.
    // Also, the height isn't quite big enough, so the images are fuzzy.
    imgThumbnailUrl() {
      const img = this.productInfo.ProductImages.find(
        (img) => img.Type.toLowerCase() == this.catalog
      );
      return typeof img !== "undefined"
        ? img.ImageUrl
        : "/images/default-card.png";
    },

    // Don't display deleted or unpublished variants
    variants() {
      return this.productInfo.ProductVariantModels.filter(
        (val) => val.Published == true && val.Deleted == false
      );
    },

    // outputs the first few links for produts or variants, and sets the rest
    // into an array. If it gets populated, then we show that in the template
    // under a "show more" type of thing.
    topVariants() {
      const variants = this.variants;
      let output = [];
      let theRest = [];

      variants.forEach((variant) => {
        if (
          variant.Name == "Acting Edition" ||
          (variant.Name || "").includes("ePlay")
        ) {
          output.push(variant);
        } else {
          theRest.push(variant);
        }
      });

      // if we still have room, add the next one
      theRest.forEach((variant, index) => {
        if (output.length < 2) {
          output.push(variant);
          theRest.splice(index, 1);
        }
      });

      this.theRest = [...theRest];

      return output;
    },

    hasImage() {
      if (this.productInfo.ProductImages) {
        const img = this.productInfo.ProductImages.find(
          (img) => img.Type.toLowerCase() == this.catalog
        );
        return typeof img !== "undefined";
      }

      return false;
    },

    customColor() {
      const bg = `bg-color-${
        this.productInfo.FeaturedColor !== null &&
        this.productInfo.FeaturedColor !== ""
          ? this.productInfo.FeaturedColor
          : "blue"
      }`;
      const font =
        this.productInfo.FeaturedColor !== null &&
        this.productInfo.FeaturedColor !== "white"
          ? "color-white"
          : "color-off-black";
      return `${bg} ${font}`;
    },

    fontColor() {
      return this.productInfo.FeaturedColor !== null &&
        this.productInfo.FeaturedColor !== "white"
        ? "color-white"
        : "color-off-black";
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/QuickViewModal.vue